import { styled } from '@mui/material/styles';

export const HeaderCell = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== '$backgroundColor' &&
    prop !== '$labelColor' &&
    prop !== 'isDateHeader' &&
    prop !== 'headerColor',
})<{ $backgroundColor: string; $labelColor: string }>(({ $backgroundColor, $labelColor }) => ({
  backgroundColor: $backgroundColor,
  color: $labelColor,
  borderRadius: '8px',
  lineHeight: '32px',
  position: 'absolute',
  textTransform: 'capitalize',
  display: 'flex',
  alignItems: 'center',
  userSelect: 'none',
  svg: {
    visibility: 'hidden',
    margin: '8px 0',
  },
  ':hover svg': {
    visibility: 'visible',
  },
  'svg:hover': {
    cursor: 'pointer',
  },
  '&:hover': {
    '.MuiButtonBase-root ': {
      backgroundColor: $backgroundColor,
      color: $labelColor,
    },
  },
}));
